<template>
  <section class="d-flex flex-wrap d-inline-flex align-start">
    <topic-cloud-item
      v-for="topic in topics"
        @onSelectedTopicChip="(event, topic) => $emit('onSelected', event, topic)"
        :key="`topic-id-${topic.id}`"
        :itemId="`topic-id-${topic.id}`"
        :value="topic.id"
        :itemTitle="topic.title"
        :actionCompleted="topic.completed"
    />
  </section>
</template>

<script>
import TopicCloudItem from './TopicCloudItem.vue';
  export default {
    components: { TopicCloudItem },
    name: 'TopicCloud',
    props: {
      topics: {
        type: Array,
        required: true
      }
    }
  };
</script>